export default {
  watch: {
    camera: {
      handler (value) {
        this.updateCamera(value)
      },
      deep: true
    }
  },
  methods: {
    cameraComponents () {
      const camera = this.camera

      const updateCamera = this.updateCamera

      updateCamera(camera)

      if (!AFRAME.components.camera) {
        AFRAME.registerComponent('camera', {
          init () {
            console.log('init camear')
            updateCamera(camera)
          },
          remove () {
            delete AFRAME.components.camera
          }
        })
      }
    },
    updateCamera (camera) {
      const cameraElement = document.getElementById('camera')
      console.log('updateCamera', camera)
      if (camera && camera.props) {
        cameraElement.setAttribute('position', `${camera.props.positionX}, ${camera.props.positionY}, ${camera.props.positionZ}`)
      }
    }
  }
}
